import React from 'react';

import { useDataContext } from 'src/context/data';
import analytics from 'src/utils/analytics/analytics';

import { formatPhoneNumber } from 'src/utils/common';

import { renderCloseIcon, renderPhoneIcon, renderArrowIcon, renderHomeIcon } from 'src/utils/iconRenderers';

import colorsModule from 'src/utils/styles/_colors.module.scss';

/* - - - - - - - - - - - - - - - - - - - - - */

const colors = colorsModule.locals;

function Header() {
  const {
    appState: {
      routerHistory,
      widgetData: { parameters, config },
    },
    setWidgetOpenedStatus,
    goBack,
    goHome,
  } = useDataContext();

  const handleBackBtnClick = () => {
    analytics.trackBackButtonPressed({ routerHistory });
    goBack();
  };

  const handleHomeBtnClick = () => {
    analytics.trackHomeButtonPressed();
    goHome();
  };

  return (
    <div
      className={`rcw-header ${parameters.isPhoneNumberEnabled ? 'header_tall' : ''}`}
      style={{ backgroundColor: parameters.titleBackgroundColor }}
      data-cy="rcw-header"
    >
      <div
        className={`header-nav-controls ${parameters.isPhoneNumberEnabled ? 'header-nav-controls_tall' : ''}`}
        data-cy="header-nav-controls"
      >
        {routerHistory.length > 1 && (
          <React.Fragment>
            <button data-cy="go-back-nav-control" onClick={handleBackBtnClick}>
              {renderArrowIcon(parameters.titleFontColor)}
            </button>
            <button data-cy="back-to-home-nav-control" onClick={handleHomeBtnClick}>
              {renderHomeIcon(parameters.titleFontColor)}
            </button>
          </React.Fragment>
        )}
      </div>

      <h4 className="rcw-title" style={{ color: parameters.titleFontColor }} data-cy="header-title">
        {parameters.title}
      </h4>

      {parameters.isPhoneNumberEnabled && (
        <div className="rcw-header-phone-number" data-cy="header-phone-number">
          <a
            className="rcw-header-phone-icon-holder"
            style={{ borderColor: parameters.phoneIconColor }}
            href={`tel:${config.phoneNumberParameters.phoneNumber}`}
            onClick={() => analytics.trackPhoneNumberPressed({ buttonType: 'icon' })}
            data-cy="header-phone-icon"
          >
            {renderPhoneIcon(parameters.phoneIconColor)}
          </a>

          <a
            className="rcw-header-phone-number-link"
            style={{ color: parameters.titleFontColor }}
            onClick={() => analytics.trackPhoneNumberPressed({ buttonType: 'number' })}
            href={`tel:${config.phoneNumberParameters.phoneNumber}`}
          >
            {formatPhoneNumber(config.phoneNumberParameters.phoneNumber as string)}
          </a>
        </div>
      )}

      <button
        className={`rcw-header-close-button ${parameters.isPhoneNumberEnabled ? 'header-close-button_tall' : ''}`}
        onClick={() => setWidgetOpenedStatus(false)}
      >
        {renderCloseIcon(colors.white)}
      </button>
    </div>
  );
}

export default Header;
